// @ts-nocheck

import HomeOutlined from '@ant-design/icons/HomeOutlined';
import PieChartOutlined from '@ant-design/icons/PieChartOutlined';
import SolutionOutlined from '@ant-design/icons/SolutionOutlined';
import ToolOutlined from '@ant-design/icons/ToolOutlined';
import AppstoreAddOutlined from '@ant-design/icons/AppstoreAddOutlined';
import CarOutlined from '@ant-design/icons/CarOutlined';
import ShoppingOutlined from '@ant-design/icons/ShoppingOutlined';
import SwitcherOutlined from '@ant-design/icons/SwitcherOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import InboxOutlined from '@ant-design/icons/InboxOutlined';
import FileProtectOutlined from '@ant-design/icons/FileProtectOutlined';
import ReadOutlined from '@ant-design/icons/ReadOutlined';
import TeamOutlined from '@ant-design/icons/TeamOutlined';
import ShoppingCartOutlined from '@ant-design/icons/ShoppingCartOutlined';
import AuditOutlined from '@ant-design/icons/AuditOutlined';
import DollarCircleOutlined from '@ant-design/icons/DollarCircleOutlined';
import ContactsOutlined from '@ant-design/icons/ContactsOutlined';
import HighlightOutlined from '@ant-design/icons/HighlightOutlined';
import LockOutlined from '@ant-design/icons/LockOutlined';
import BranchesOutlined from '@ant-design/icons/BranchesOutlined';
import BgColorsOutlined from '@ant-design/icons/BgColorsOutlined';
import VideoCameraOutlined from '@ant-design/icons/VideoCameraOutlined';
import FlagOutlined from '@ant-design/icons/FlagOutlined';
import RedoOutlined from '@ant-design/icons/RedoOutlined';
import MailOutlined from '@ant-design/icons/MailOutlined';
import LineChartOutlined from '@ant-design/icons/LineChartOutlined';
import ProfileOutlined from '@ant-design/icons/ProfileOutlined';
import SmileOutlined from '@ant-design/icons/SmileOutlined';
import UserAddOutlined from '@ant-design/icons/UserAddOutlined';
import RocketOutlined from '@ant-design/icons/RocketOutlined';
import EnvironmentOutlined from '@ant-design/icons/EnvironmentOutlined';
import UsergroupAddOutlined from '@ant-design/icons/UsergroupAddOutlined';
import UserSwitchOutlined from '@ant-design/icons/UserSwitchOutlined';
import TrophyOutlined from '@ant-design/icons/TrophyOutlined';
import BorderOuterOutlined from '@ant-design/icons/BorderOuterOutlined';
import AlignLeftOutlined from '@ant-design/icons/AlignLeftOutlined';
import SnippetsOutlined from '@ant-design/icons/SnippetsOutlined'

export default {
  HomeOutlined,
PieChartOutlined,
SolutionOutlined,
ToolOutlined,
AppstoreAddOutlined,
CarOutlined,
ShoppingOutlined,
SwitcherOutlined,
UserOutlined,
InboxOutlined,
FileProtectOutlined,
ReadOutlined,
TeamOutlined,
ShoppingCartOutlined,
AuditOutlined,
DollarCircleOutlined,
ContactsOutlined,
HighlightOutlined,
LockOutlined,
BranchesOutlined,
BgColorsOutlined,
VideoCameraOutlined,
FlagOutlined,
RedoOutlined,
MailOutlined,
LineChartOutlined,
ProfileOutlined,
SmileOutlined,
UserAddOutlined,
RocketOutlined,
EnvironmentOutlined,
UsergroupAddOutlined,
UserSwitchOutlined,
TrophyOutlined,
BorderOuterOutlined,
AlignLeftOutlined,
SnippetsOutlined
}
    